import { EntityType } from '../../../@types/entityTypes';
import PayByLinkWorkspaceQuery from 'graphql/queries/salesLedger/PayByLinkWorkspaceQuery.graphql';
import { actions } from '../../../actions/salesLedger/PayByLinkWorkspaceAction';

const PayByLink: EntityType = {
  screenReference: 'SALES_LEDGER_PAY_BY_LINK',
  type: 'PayByLink',
  title: 'Pay By Link',
  workspaceUrl: '/Customers/PayByLink/Workspace/',
  workspace: PayByLinkWorkspaceQuery,
  actions,
};

export default PayByLink;
